<template>
  <el-drawer
    :visible.sync="aDrawer"
    :direction="direction"
    :append-to-body="true"
    size="100%"
    custom-class="post-drawer"
    >
    <div class="post-drawer__content">
      <p class="post-drawer__title">
        {{$t('post.create.title')}}
      </p>

      <el-divider></el-divider>

      <div class="form-wrap" v-loading="pending" v-bar>
        <div>
          <el-form
            ref="postForm"
            :model="form"
            label-position="top"
            :rules="rules"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item :label="$t('post.create.form.network.label')" prop="postNetwork">
              <el-select v-model="form.postNetwork" :placeholder="$t('post.create.form.network.placeholder')">
                <el-option
                  v-for="item in social"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('post.create.form.url.label')" prop="url">
              <el-input v-model="form.url" :placeholder="$t('post.create.form.url.placeholder')"></el-input>
            </el-form-item>

            <el-form-item :label="$t('post.create.form.owner_url.label')" prop="owner_url" v-if="form.postNetwork === gsmId">
              <el-input v-model="form.owner_url" :placeholder="$t('post.create.form.owner_url.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('post.create.form.title.label')" prop="title" v-if="form.postNetwork === gsmId">
              <el-input v-model="form.title" :placeholder="$t('post.create.form.title.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('post.create.form.created_date.label')" prop="created_date" v-if="form.postNetwork === gsmId">
              <el-date-picker
                v-model="form.created_date"
                type="datetime"
                :placeholder="$t('post.create.form.created_date.placeholder')">
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('post.create.form.content.label')" prop="content" v-if="form.postNetwork === gsmId">
              <el-input type="textarea" v-model="form.content" :placeholder="$t('post.create.form.content.placeholder')"></el-input>
            </el-form-item>

            <el-divider></el-divider>

            <el-form-item>
              <el-button type="primary" @click="onSubmit('postForm')">{{$t('post.create.form.addButton')}}</el-button>
              <el-button @click="resetForm('postForm')">{{$t('post.create.form.cancelButton')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
  import dictionary from "./validator/dictionary";
  import notify from "../../../../../../../../helpers/notify";

  // options
  import options from '../options/sidebarOptions';
  import { netOptions } from "./validator/dictionary";

  // api
  import { addPost } from '@/api/publications';

  // moment
  import moment from 'moment';

  export default {
    name: 'newPost',
    props: {
      drawer: {
        type: Boolean,
      },
    },
    data() {
      return {
        social: this.$t('post.create.social'),
        direction: 'rtl',
        pending: false,
        gsmId: '4',
        form: {
          postNetwork: '1',
          url: '',
          owner_url: '',
          title: '',
          created_date: '',
          content: '',
        },
        format: "DD-MM-YYYY HH:MM:SS",
      };
    },
    computed: {
      rules() {
        return this.form.postNetwork === this.gsmId ? this.$t('post.create.dictionary') : this.$t('post.create.netOptions');
      },
      aDrawer: {
        get() {
          return this.drawer;
        },
        set() {
          this.$emit('toggleDrawer');
        }
      }
    },
    methods: {
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      onSubmit(formName) {
        this.pending = true;

        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addPost(formName)
          } else {
            notify.call(this, this.$t('post.create.notify.error'), "error");
            this.pending = false;
            return false;
          }
        });
      },
      getParams() {
        if (this.form.postNetwork === this.gsmId) {
          return {
            thread_id: this.$route.params.threadId,
            network_id: this.form.postNetwork,
            url: this.form.url,
            owner_url: this.form.owner_url,
            title: this.form.title,
            content: this.form.content,
            created_date: moment(this.form.created_date).format(this.format),
          }
        } else {
          return {
            thread_id: this.$route.params.threadId,
            network_id: this.form.postNetwork,
            url: this.form.url,
          }
        }
      },
      addPost(formName) {

        const params = this.getParams();

        addPost(params).then(() => {
          this.pending = false;
          notify.call(this, this.$t('post.create.notify.saved'), "success");
          this.$refs[formName].resetFields();
        }).catch(() => {
          this.pending = false;
          notify.call(this, this.$t('post.create.notify.incorrect'), "error");
        });
      }
    },
  };
</script>

<style>
  .post-drawer__content {
    height: inherit;
    padding: 20px;
  }
  .form-wrap {
    height: 80vh;
  }
  .post-drawer__title {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 14px;
    color: #5E6D82;
  }
</style>
